import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h12.6a.7.7 0 0 1 .7.7v12.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v1.75h11.2V4.4H4.4Zm11.2 3.15H4.4v8.05h11.2V7.55Zm-3.071 1.43a.7.7 0 0 1 .416.64v3.388h.49a.7.7 0 1 1 0 1.4H11.05a.7.7 0 0 1-.001-1.4h.495v-1.812l-.025.023a.7.7 0 1 1-.939-1.04l1.195-1.078a.7.7 0 0 1 .753-.12Zm-4.546 1.341c-.152 0-.295.101-.347.28a.7.7 0 0 1-1.345-.39c.21-.721.86-1.29 1.692-1.29.982 0 1.78.795 1.78 1.778 0 .36-.115.693-.31.965.195.273.31.606.31.966 0 .982-.797 1.778-1.78 1.778-.831 0-1.483-.57-1.692-1.29a.7.7 0 0 1 1.345-.39c.052.178.195.28.347.28.21 0 .38-.17.38-.378a.266.266 0 0 0-.267-.266.7.7 0 1 1 0-1.4c.147 0 .266-.12.266-.265a.378.378 0 0 0-.379-.378Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
